import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Twitter } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
              <Logo className="h-7 w-auto" testid="footer-brand-logo" />
            </Link>
            <p className="mt-4 text-sm text-zinc-500 max-w-xs">
              India's outcome-obsessed creator marketing agency. Built for brand teams that report
              to a CFO.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white hover:border-blue-500/40" href="#" aria-label="Instagram">
                <Instagram className="h-4 w-4" />
              </a>
              <a className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white hover:border-blue-500/40" href="#" aria-label="LinkedIn">
                <Linkedin className="h-4 w-4" />
              </a>
              <a className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white hover:border-blue-500/40" href="#" aria-label="Twitter">
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wider text-zinc-500 mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" className="text-zinc-300 hover:text-blue-300">Services</a></li>
              <li><a href="#case-studies" className="text-zinc-300 hover:text-blue-300">Case Studies</a></li>
              <li><a href="#about" className="text-zinc-300 hover:text-blue-300">About</a></li>
              <li><a href="#" className="text-zinc-300 hover:text-blue-300">Careers</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wider text-zinc-500 mb-4">Legal</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-zinc-300 hover:text-blue-300">Privacy Policy</a></li>
              <li><a href="#" className="text-zinc-300 hover:text-blue-300">Terms</a></li>
              <li><Link to="/login" className="text-zinc-300 hover:text-blue-300">Admin</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wider text-zinc-500 mb-4">Contact</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li>hello@bagfluence.com</li>
              <li>+91 22 6789 0000</li>
              <li>Mumbai · Bangalore</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">© {new Date().getFullYear()} Bagfluence. All rights reserved.</p>
          <p className="text-xs text-zinc-500">Made for brand teams who count every rupee.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
